
import React from 'react';
import { Link } from 'react-router-dom';
import { Search, Activity, AlertTriangle } from 'lucide-react';
import { SUPPORTED_APPS } from '../constants';
import SEO from '../components/SEO';

const SupportedApps: React.FC = () => {
  return (
    <div className="pt-24 pb-16 min-h-screen">
      <SEO 
        title="Daftar Aplikasi Didukung - Optimasi E-Presensi & Absensi Online"
        description="Lihat daftar aplikasi absensi online yang didukung oleh XCape. Termasuk e-Presensi DKI, SiapKK, Mobile JKN, dan Talenta. Update status sistem real-time."
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-slate-900 mb-4">Aplikasi yang Didukung</h1>
          <p className="text-slate-500">Database kompatibilitas XCape. Diupdate setiap hari.</p>
        </div>

        {/* Search Bar (Visual Only) */}
        <div className="max-w-xl mx-auto mb-12 relative">
          <input 
            type="text" 
            placeholder="Cari aplikasi absensi Anda..." 
            className="w-full bg-white border border-slate-200 rounded-xl py-4 pl-12 pr-4 text-slate-900 focus:outline-none focus:border-brand-primary focus:ring-2 focus:ring-brand-primary/20 transition-all shadow-sm"
          />
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 h-5 w-5" />
        </div>

        {/* Apps Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {SUPPORTED_APPS.map((app) => (
            <Link to={`/aplikasi/${app.slug}`} key={app.id} className="block group">
              <div className="bg-white border border-slate-200 rounded-xl p-6 hover:border-brand-primary hover:shadow-lg transition-all h-full flex flex-col">
                <div className="flex justify-between items-start mb-4">
                  <div className="h-14 w-14 bg-gradient-to-br from-slate-100 to-slate-200 rounded-xl flex items-center justify-center border border-slate-300">
                    <span className="text-2xl font-bold text-slate-600 group-hover:text-brand-primary transition-colors">{app.name.charAt(0)}</span>
                  </div>
                  {app.status === 'active' ? (
                    <div className="flex items-center text-green-700 text-xs font-medium bg-green-100 px-2 py-1 rounded-full border border-green-200">
                      <Activity className="w-3 h-3 mr-1" /> Working
                    </div>
                  ) : (
                    <div className="flex items-center text-yellow-700 text-xs font-medium bg-yellow-100 px-2 py-1 rounded-full border border-yellow-200">
                      <AlertTriangle className="w-3 h-3 mr-1" /> {app.status}
                    </div>
                  )}
                </div>
                
                <h3 className="text-xl font-bold text-slate-900 mb-2 group-hover:text-brand-primary transition-colors">{app.name}</h3>
                <p className="text-sm text-slate-500 mb-4 flex-grow">{app.description}</p>
                
                <div className="border-t border-slate-100 pt-4 mt-auto">
                  <div className="flex justify-between text-xs text-slate-400">
                    <span>Versi: {app.version}</span>
                    <span>Tested: {app.lastTested}</span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Request Form Section */}
        <div className="bg-white rounded-3xl p-8 md:p-12 border border-slate-200 shadow-xl text-center relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-orange-100 rounded-full mix-blend-multiply filter blur-3xl opacity-50"></div>
          <div className="relative z-10">
            <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-4">Tidak Menemukan Aplikasi Anda?</h2>
            <p className="text-slate-500 mb-8 max-w-2xl mx-auto">
                Kami secara aktif mencari tantangan baru. Beritahu kami aplikasi apa yang kantor Anda gunakan, dan kami akan membuat profil kalibrasinya.
            </p>
            <a href="https://calibrate.xcape.my.id/" target="_blank" rel="noopener noreferrer" className="inline-block px-8 py-3 bg-brand-primary text-white font-bold rounded-lg hover:bg-orange-600 transition-colors shadow-lg shadow-orange-500/30">
                Request Aplikasi Baru
            </a>
          </div>
        </div>

      </div>
    </div>
  );
};

export default SupportedApps;
